import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import {BrowserRouter as Router } from 'react-router-dom'
import './index.css';
import App from './App';
import configureStore from './store'
import ScrollToTop from './components/ScrollToTop'
// import * as serviceWorker from './serviceWorker';

const store = configureStore()

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <ScrollToTop>
                <App/>
            </ScrollToTop>
        </Router>
    </Provider>, 
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
